<template>
    <div class="product-list-short">
        <template v-if="loading">
            <Loading>
                <template v-slot:title>
                    Loading your data…
                </template>
            </Loading>
        </template>
        <template v-else>
            <div class="product-list-short__item" v-for="product in products">
                <div class="product-list-short__item-inside">

                    <div class="product-list-short__item-visual" v-if="product.icon" v-html="`<i data-icon='&#x${product.icon};'></i>`"></div>
                    <div class="product-list-short__item-visual" v-else-if="product.image">
                        <img :src="product.image.src" :alt="product.image.alt" :width="product.image.width" :height="product.image.height" :title="product.image.title">
                    </div>

                    <div class="product-list-short__item-content">
                        <h2 class="product-list-short__item-name">{{ product.name }}</h2>

                        <div class="product-list-short__item-price product-price product-price--lg">
                            <div class="product-price__value">{{ product.price }}</div>
                            <div class="product-price__text">(VAT incl.)</div>
                        </div>
                    </div>

                    <div class="product-list-short__item-buttons">
                        <div class="buttons-group-sm buttons-group--no-wrap">
                            <button class="btn btn-secondary btn-one-icon rounded-circle" v-tippy="{ allowHTML: true, content: product.teaser, placement : isMobile() ? 'bottom'  : 'left-start' }" v-if="product.teaser" :aria-label="`More info about ${product.name}`">
                                <i class="icon icon-info" aria-hidden="true"></i>
                            </button>

                            <button class="btn btn-primary btn-one-icon rounded-circle" :content="product.inCart ? 'Remove from Cart' : 'Add to Cart'" v-tippy="{ placement : 'top' }" @click="product.inCart ? onProductRemove(product) : onProductAdd(product)" :disabled="loadingProductId" :aria-label="product.inCart ? `Remove ${product.name} from cart` : `Add ${product.name} to cart`">
                                <i class="icon" :class="loadingProductId === product.id  ? 'spinner-border spinner-border-sm' : product.inCart ? 'icon-x': 'icon-shopping-bag'" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loading from "../../../_components/Loading";
    import { httpClient } from '../../../_helpers/http-client';
    import { cartObserver } from '../../../_helpers/cart-observer';

    export default {
        name: 'ServiceList',
        components: { Loading },
        data() {
            return {
                loading: true,
                loadingProductId: null,
                products: [],
            };
        },
        methods: {
            isMobile() {
                return window.matchMedia('(max-width: 576px)').matches;
            },
            onProductAdd(product) {
                this.loadingProductId = product.id;
                httpClient.post(this.$config.addProductUrl, { product: product.id, quantity: 1 }).then(() => {
                    this.products.find(v => v.id === product.id).inCart = true;

                    cartObserver.update(this);
                    cartObserver.showCart();
                }).finally(() => this.loadingProductId = null);
            },
            onProductRemove(product) {
                this.loadingProductId = product.id;
                httpClient.post(this.$config.removeProductUrl, { product: product.id, quantity: 0 }).then(() => {
                    this.products.find(v => v.id === product.id).inCart = false;

                    cartObserver.update(this);
                    cartObserver.showCart();
                }).finally(() => this.loadingProductId = null);
            },
        },
        mounted() {
            httpClient.get(this.$config.getCartUrl).then(response => {
                this.products = this.$config.products.map(product => ({...product, inCart: response.data.items.some(item => item.id === product.id) }));

                cartObserver.update(this, response.data);
                cartObserver.subscribe((data, initiator) => {
                    if (initiator !== this) {
                        this.products.forEach(product => product.inCart = data.items.some(item => item.id === product.id));
                    }
                });
            }).finally(() => this.loading = false);
        },
    }
</script>
